/**
 * LinaTypingIndicator.tsx
 * Animated typing indicator showing LINA is generating a response
 * Used across all tools and support chat
 */

interface LinaTypingIndicatorProps {
  message?: string
}

export const LinaTypingIndicator = ({ message = 'LINA is typing' }: LinaTypingIndicatorProps) => {
  return (
    <div className="flex items-center justify-start">
      <div
        className="text-sm rounded-lg p-3 max-w-[80%] flex items-center gap-2"
        style={{
          background: 'hsl(var(--gradient-warm))',
          color: 'hsl(var(--text-primary))',
        }}
      >
        <span className="mr-2">{message}</span>
        {/* Animated dots */}
        <div className="flex items-center gap-1.5">
          <span
            className="w-2 h-2 rounded-full animate-bounce"
            style={{
              background: 'var(--gradient-primary)',
              animationDelay: '0s',
            }}
          />
          <span
            className="w-2 h-2 rounded-full animate-bounce"
            style={{
              background: 'var(--gradient-accent)',
              animationDelay: '0.2s',
            }}
          />
          <span
            className="w-2 h-2 rounded-full animate-bounce"
            style={{
              background: 'var(--gradient-warm)',
              animationDelay: '0.4s',
            }}
          />
        </div>
      </div>
    </div>
  )
}
